import { Outlet } from "react-router-dom"

const AdminLanding = () => {
  return <div>
    Admin Landing
  </div>
}
export default AdminLanding